import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=2fea6771&scoped=true&"
import script from "./OrganizationInfo.vue?vue&type=script&lang=js&"
export * from "./OrganizationInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationInfo.vue?vue&type=style&index=0&id=2fea6771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea6771",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardTitle,VDivider,VTab,VTabItem,VTabs})
